<template>
  <SogForm
    ref="_form"
    :validations="_validations"
  >
    <SogFormField>
      <SogRadioButtonGroup
        v-model="_value.person.sex"
        :items="_sexItems"
        name="Sex"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_value.person.name2"
        placeholder="Vorname"
        autocomplete="true"
        name="Vorname"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_value.person.name1"
        placeholder="Nachname*"
        autocomplete="true"
        name="Nachname"
      />
    </SogFormField>
  </SogForm>
</template>


<script setup lang="ts">

import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogRadioButtonGroup from "@/shared/ui/SogRadioButtonGroup.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";

import {ref} from "vue";
import {withDefaults} from "vue";
import Person from "@/shared/model/person";
import {reactive, watch} from "vue";
import SogRadioButtonGroupItem from "@/shared/ui/types/SogRadioButtonGroupItem";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";

interface Props {
  person: Person,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  person: () => new Person()
});

const _form = ref<InstanceType<typeof SogForm> | null>(null)
const _value = reactive({person: props.person})
const _sexItems: SogRadioButtonGroupItem[] = [{label: "Herr", value: "M"}, {label: "Frau", value: "W"}]

const _validations: SogFormValidationRule[] = [
  {name: 'Nachname', rules: {required: [true, "Geben Sie einen Namen ein."]}},
]

watch(props, () => {
    _value.person = props.person;
  }, {immediate: true}
)
const validate = (): boolean => {
  if (_form.value)
    return _form.value.validate();
  return false;
}

const getPerson = (): Person => {
  return _value.person;
}
defineExpose({
  validate, getPerson
})
</script>

<style scoped>

</style>
